import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const paises = `${baseUrl}/ubigeo/paises`;

export const allPaisesService = async () => {
  try {
    const res = await axios.get(paises, {
      headers: token({}),
    });
    return res;
  } catch (e) {
    console.log(e);
  }
};
